import React, { useState } from "react";
import ScrollToTop from "react-scroll-to-top";
import { useTheme } from "@mui/material/styles";
import {
  Button,
  Container,
  Grid,
  Typography,
  Box,
} from "@mui/material";

import BottomCurved from "../../components/layout/BottomCureved";
import CreateTicket from "../../components/layout/CreateTicket";
import SentTicketSuccessModal from "../../components/layout/SentTicketSuccessModal";

import IMG_HELP_01 from "../../assets/img/help-01.png";
import IMG_HELP_02 from "../../assets/img/help-02.png";
import IMG_HELP_03 from "../../assets/img/help-03.png";
import "./Help.style.css";


const HelpPage = () => {
  const theme = useTheme();

  const [createTicketModal, setCreateTicketModal] = useState(false);
  const [successModal, setSuccessModal] = useState(false);

  const onCloseCreateTicketModal = () => setCreateTicketModal(false);
  const onCloseSuccessModal = () => setSuccessModal(false);

  const onCreateTicket = () => {
    setCreateTicketModal(true);
  }

  const onCreatedTicketSuccessed = () => {
    setSuccessModal(true);
  }
  const onCloseSuccess = () => {
    onCloseSuccessModal();
    setCreateTicketModal(false);
  }

  const onTwitter = () => {
    window.open('https://twitter.com/clientl_app', "_blank");
  }

  return (
    <>
      <BottomCurved />
      <Container maxWidth="lg">
        <Grid
          item
          className="page-title"
          container
          justifyContent='space-between'
          sx={{ my: { sm: 2, md: 5 }, marginInline: 'auto', zIndex: 10 }}
        >
          <Grid item>
            <Typography sx={{ color: '#fff', fontSize: '1.5rem', fontWeight: 600 }}>Support Center</Typography>
          </Grid>
          <Grid item>
            <Button
              onClick={onCreateTicket}
              color="success"
              variant="contained"
              sx={{
                padding: '11px 20px',
                fontSize: '14px',
                fontWeight: 500,
                textTransform: 'none',
                color: '#fff'
              }}>
              Create Ticket
            </Button>
          </Grid>
        </Grid>
        <Grid alignItems="center" justifyContent="center" marginTop="40px">
          <Typography sx={{ color: '#fff', fontSize: '40px', fontWeight: '600', textAlign: 'center' }}>Get In Touch</Typography>
          <Typography sx={{ color: theme.palette.mode === 'light' ? '#a1a5b7' : '#565674', fontSize: { sm: '17px', md: '20px' }, fontWeight: { sm: '400', md: '500' }, textAlign: 'center', maxWidth: '70%', margin: '0 auto' }}>
            Questions? Feature Requests?<br/>Our legendary service is here to support you every step of the way.
          </Typography>
        </Grid>
        <Grid
          container
          spacing={2}
          sx={{ mt: 10 }}
        >
          <Grid item xs={4} display="flex" flexDirection="column" flexBasis="100%" alignItems="center" maxWidth="100%">
            <Box component="img" className="octagon" src={IMG_HELP_01} style={{ width: '300px' }} />
            <Typography sx={{ color: theme.palette.mode === 'light' ? '#181c32' : '#fff', fontSize: '24px', fontWeight: '700', textAlign: 'center', mt: 3 }}>Sales</Typography>
            <Typography sx={{ color: theme.palette.mode === 'light' ? '#3f4254' : '#cdcdde', fontSize: '0.925rem', fontWeight: '300', textAlign: 'center', mt: 1.5, padding: '0 25px' }}>
              Need help with your account? Or discover how Clientl can help your business? We're happy to chat.
            </Typography>
            <Typography sx={{ color: theme.palette.mode === 'light' ? '#5e6278' : '#92929f', fontSize: '14px', fontWeight: '600', textAlign: 'center', mt: 2 }}>
              Email: <span style={{ color: theme.palette.mode === 'light' ? '#a1a5b7' : '#565674' }}>team@client.app</span>
            </Typography>
          </Grid>
          <Grid item xs={4} display="flex" flexDirection="column" flexBasis="100%" alignItems="center" maxWidth="100%">
            <Box component="img" className="octagon" src={IMG_HELP_02} style={{ width: '300px' }} />
            <Typography sx={{ color: theme.palette.mode === 'light' ? '#181c32' : '#fff', fontSize: '24px', fontWeight: '700', textAlign: 'center', mt: 3 }}>Support</Typography>
            <Typography sx={{ color: theme.palette.mode === 'light' ? '#3f4254' : '#cdcdde', fontSize: '0.925rem', fontWeight: '300', textAlign: 'center', mt: 1.5, padding: '0 25px' }}>
              Our support team is here 7 days a week to help with troubleshooting & technical questions.
            </Typography>
            <Typography sx={{ color: theme.palette.mode === 'light' ? '#5e6278' : '#92929f', fontSize: '14px', fontWeight: '600', textAlign: 'center', mt: 2 }}>
              Support: <span onClick={onCreateTicket} style={{ color: theme.palette.mode === 'light' ? '#a1a5b7' : '#565674', cursor: 'pointer' }}>Submit Ticket Here</span>
            </Typography>
          </Grid>
          <Grid item xs={4} display="flex" flexDirection="column" flexBasis="100%" alignItems="center" maxWidth="100%">
            <Box component="img" className="octagon" src={IMG_HELP_03} style={{ width: '300px' }} />
            <Typography sx={{ color: theme.palette.mode === 'light' ? '#181c32' : '#fff', fontSize: '24px', fontWeight: '700', textAlign: 'center', mt: 3 }}>Community</Typography>
            <Typography sx={{ color: theme.palette.mode === 'light' ? '#3f4254' : '#cdcdde', fontSize: '0.925rem', fontWeight: '300', textAlign: 'center', mt: 1.5, padding: '0 25px' }}>
              Join the Clientl community by following our Twitter for the latest news and product updates.
            </Typography>
            <Typography sx={{ color: theme.palette.mode === 'light' ? '#5e6278' : '#92929f', fontSize: '14px', fontWeight: '600', textAlign: 'center', mt: 2 }}>
              Twitter: <span onClick={onTwitter} style={{ color: theme.palette.mode === 'light' ? '#a1a5b7' : '#565674', cursor: 'pointer' }}>@clientl_app</span>
            </Typography>
          </Grid>
        </Grid>
        <CreateTicket
          visible={createTicketModal}
          onClose={onCloseCreateTicketModal}
          onCreatedTicketSuccessed={onCreatedTicketSuccessed}
        />
        <SentTicketSuccessModal
          visible={successModal}
          onClose={onCloseSuccessModal}
          onCloseSuccess={onCloseSuccess}
        />
        <ScrollToTop
          smooth
          color="#009EF7"
        />
      </Container>
    </>
  );
}

export default HelpPage;
